import {
  Button,
  Card,
  Col,
  Form,
  Input,
  InputNumber,
  Modal,
  Row,
  Typography,
  message,
} from "antd";
import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addEmailConfiguration, loadEmailConfig, sendTestEmail } from "../../redux/rtk/features/emailConfiguration/emailConfigSlice";

const { Title } = Typography;

const EmailConfiguration = () => {
  const [form] = Form.useForm();
  const [loader, setLoader] = useState(false);
  const [isTestButtonEnabled, setIsTestButtonEnabled] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [to, setTo] = useState("");
  const dispatch = useDispatch();
  
  // Fetch email configuration data on component mount
  useEffect(() => {
    dispatch(loadEmailConfig());
  }, [dispatch]);

  // Select email configuration data from Redux
  const list = useSelector((state) => state.emailConfiguration.emailConfig) || [];

  // Prefill form fields when `list` is updated
  useEffect(() => {
    if (list && Object.keys(list).length > 0) {
      form.setFieldsValue({
        emailId: list.emailId,
        password: list.password,
        host: list.host,
        port: list.port,
      });
      setIsTestButtonEnabled(true); // Enable the test email button
    }
  }, [list, form]);

  const handleFormSubmit = (values) => {
    setLoader(true);
    dispatch(addEmailConfiguration(values))
      .then(() => {
        setLoader(false);
        message.success("Configuration saved successfully!");
        setIsTestButtonEnabled(true);
      })
      .catch(() => {
        setLoader(false);
        message.error("Failed to save configuration.");
      });
  };

  const handleTestEmail = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    if (to) {
      dispatch(sendTestEmail({ to }))
        .then(() => {
          message.success("Test email sent successfully!");
          setIsModalVisible(false);
        })
        .catch(() => {
          message.error("Failed to send test email.");
        });
    } else {
      message.error("Please enter a recipient email!");
    }
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleToMailChange = (e) => {
    setTo(e.target.value);
  };

  return (
    <Fragment>
      <Card>
        <Row justify="center">
          <Col span={12}>
            <Title level={3} className="text-center">
              Email Configuration
            </Title>
            <Form
              form={form}
              layout="vertical"
              name="email-configuration-form"
              onFinish={handleFormSubmit}
              autoComplete="off"
            >
              <Form.Item
                label="Email ID"
                name="emailId"
                rules={[
                  { required: true, message: "Please enter the email ID!" },
                  { type: "email", message: "Please enter a valid email!" },
                ]}
              >
                <Input placeholder="Enter email ID" />
              </Form.Item>

              <Form.Item
                label="Password"
                name="password"
                rules={[
                  { required: true, message: "Please enter the password!" },
                ]}
              >
                <Input.Password placeholder="Enter password" visibilityToggle={false} />
              </Form.Item>

              <Form.Item
                label="SMTP Host"
                name="host"
                rules={[{ required: true, message: "Please enter the host!" }]}
              >
                <Input placeholder="Enter host" />
              </Form.Item>

              <Form.Item
                label="Port"
                name="port"
                rules={[
                  { required: true, message: "Please enter the port number!" },
                ]}
              >
                <InputNumber
                  placeholder="Enter port number"
                  style={{ width: "100%" }}
                />
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={loader}
                  block
                >
                  Save
                </Button>
              </Form.Item>

              <Form.Item>
                <Button
                  type="default"
                  onClick={handleTestEmail}
                  disabled={!isTestButtonEnabled}
                  block
                >
                  Test Email
                </Button>
              </Form.Item>
            </Form>
          </Col>
        </Row>
      </Card>
      <Modal
        title="Send Test Email"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <Form>
          <Form.Item
            label="To Email"
            name="to"
            rules={[
              { required: true, message: "Please enter the recipient's email!" },
              { type: "email", message: "Please enter a valid email!" },
            ]}
          >
            <Input
              value={to}
              onChange={handleToMailChange}
              placeholder="Enter recipient email"
            />
          </Form.Item>
        </Form>
      </Modal>
    </Fragment>
  );
};

export default EmailConfiguration;
